import React, { useEffect } from "react";
import { Modal, Button, Form, Input } from "antd";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";

const ShopPopup = ({ show, close, details }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      name: details.name,
    });
    // eslint-disable-next-line
  }, []);

  const handleOk = async () => {
    try {
      let obj = { ...{ id: details.id }, ...form.getFieldsValue() };
      if (obj.name) {
        const data = await axios.post("/variant-create", obj).catch((error) => {
          Helper.ErrorHanlder(error);
        });
        if (data && data.data) close(data);
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const handleCancel = () => {
    close();
  };

  return (
    <>
      <Modal
        title={details ? "Update Size" : "Create Size"}
        open={show}
        onCancel={handleCancel}
        footer={false}
      >
        <Form
          layout={"vertical"}
          form={form}
          size={"small"}
          labelCol={{
            span: 6,
          }}
          style={{
            marginTop: 30,
          }}
        >
          <Form.Item
            label="Variant Name"
            name="name"
            rules={[
              {
                required: true,
                message: "Variant Name is required",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item className="popup-submit">
            <Button className="popup-cancel-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              className="popup-submit-btn"
              onClick={handleOk}
            >
              {details.id ? "Update" : "Create"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ShopPopup;
